<template>
	<m-layout class="history">
    <div fill-height class="fill-height" style="height:100%; width:100%">
      <v-layout wrap grid-list-md style="height: 100%;">
        <div v-show="map" id="map_canvas" style="height:100%; width:100%; margin:0; border: solid 1px #ededed;"></div>
      </v-layout>
    </div>
	</m-layout>
</template>
<script>
import { database } from '@/services/firebase';
import Styles from '@/components/googlemaps/styles';
// import Driver from '@/components/driver/driver';

export default {
  data () {
    return {
      refLoc: database.ref('positions'),
      locations: [],
      map: null,
      markers: []
    }
  },
  methods: {
    initMap (map) {
      this.map = new google.maps.Map(document.getElementById(map), {
        zoom: 10,
        center: { lat: 50.86, lng: 4.3517 },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        styles: (Styles && Styles.simple) || null,
        maxZoom: 16
      });
    },
    getLocations () {
      return new Promise((resolve, reject) => {
        var app = this;
        app.locations = {};
        this.refLoc.orderByChild('time').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            var item = childSnapshot.val();
            var key = childSnapshot.key;
            app.locations[key] = app.locations[key] || [];
            app.locations[key] = Object.keys(item).map((loc) => {
              return {
                time: item[loc].time,
                pos: {
                  lat: item[loc].pos[0],
                  lng: item[loc].pos[1]
                }
              }
            })
          });
          console.log('locations', app.locations);
          resolve(app.locations);
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    setPath (driver) {
      var path = this.locations[driver].map((loc) => {
        console.log(path)
        var marker = new google.maps.Marker({
          position: loc.pos,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 4
          },
          draggable: true,
          map: this.map
        });
        this.markers.push(marker);
      });
    },
    getData () {
      // var app = this;
      this.getLocations().then(() => {
        // app.setPath(419, app.map);
      });
    }
  },
  created () {
    this.getData();
  },
  mounted () {
    this.initMap('map_canvas');
  }
};
</script>
<style lang="scss">
  .history {
    .google-map {
      width: 800px;
      height: 600px;
      margin: 0 auto;
      background: gray;
    }
  }
</style>
